// Prompt Queue type definitions — mirrors backend QueueStatus constants

export enum QueueStatus {
  CURRENT = 'CURRENT',
  QUEUED = 'QUEUED',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  STOPPED = 'STOPPED',
  CANCELLED = 'CANCELLED',
}

export enum QueueIntervention {
  NONE = 'NONE',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
}

export interface QueueJobData {
  user_message: string;
  model_preference?: string;
  interaction_mode?: string; // 'agent' | 'ask' — mirror of settings.ask_mode
  settings?: Record<string, boolean>;
  file_ids?: string[];
  artifact_ids?: string[];
  image_ids?: string[];
  attachments?: any[]; // Full Attachment objects from frontend
}

/** Identity of the user who added a queued prompt (mirrors data.user_info on the backend). */
export interface QueueUserInfo {
  id?: string;
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
}

export interface QueueJob {
  job_id: string;
  thread_id: string;
  status: QueueStatus;
  intervention?: QueueIntervention;
  position?: number;          // Only set for QUEUED status
  user_message: string;
  settings?: Record<string, boolean>;
  model_preference?: string;
  interaction_mode?: string; // 'agent' | 'ask' — mirror of settings.ask_mode
  created_at?: string;
  updated_at?: string;
  completed_at?: string;
  file_ids?: string[];
  artifact_ids?: string[];
  image_ids?: string[];
  attachments?: any[];
  user_info?: QueueUserInfo;  // Who added this prompt
}

export interface QueueState {
  project_id: string;
  jobs: QueueJob[];
}
